import Button from '@atlaskit/button';
import { B400, N0, N300, N500, N700, N800, N900 } from '@atlaskit/theme/colors';
import styled from 'styled-components';
import { teamBase64 } from './assets/team';

const preMobileBreakpoint = '778px';

export const Root = styled.section`
  display: flex;
  flex-direction: row;
  max-width: 1306px;
  min-height: 300px;
  margin: 20px auto;
  padding: 10px 16px 24px;
  box-shadow: 1px 1px 3px 4px rgba(0, 0, 0, 0.11);
  color: ${N500};

  font-weight: 500;
  font-style: normal;
  font-family: Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
    Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif;

  @media (max-width: 806px) {
    box-shadow: none;
    padding: 0px 0px 24px;
  }

  @media (max-width: 768px) {
    width: 83.33333%;
  }

  @media (max-width: ${preMobileBreakpoint}) {
    width: 100%;
    flex-direction: column;
  }

  @media (max-width: 510px) {
    padding-top: 0px;
    margin-top: 10px;
  }
`;

export const CharlieDisplayFontStack =
  "'Charlie Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif;";

export const CharlieTextFontStack =
  "'Charlie Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif;";

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: start;
  width: 100%;
`;

export const LeftColumn = styled(Column)`
  padding: 10px 20px 10px 46px;
  width: 50%;

  @media (max-width: 924px) {
    padding: 10px 20px 10px 20px;
  }

  @media (max-width: 868px) {
    padding: 10px 10px 10px 0px;
  }

  @media (max-width: ${preMobileBreakpoint}) {
    width: 100%;
    padding: 16px 0;
  }

  @media (max-width: 510px) {
    padding: 0;
  }
`;

export const RightColumn = styled(Column)`
  padding: 10px 46px 10px 20px;
  width: 50%;

  @media (max-width: 924px) {
    padding: 10px 20px 10px 20px;
  }

  @media (max-width: 868px) {
    padding: 10px 0px 10px 10px;
  }

  @media (max-width: ${preMobileBreakpoint}) {
    width: 100%;
    padding: 16px 0;
  }
`;

export const MainHeading = styled.h1`
  font-family: ${CharlieDisplayFontStack};
  margin-bottom: 12px;
  font-size: 52px;
  font-weight: 500;
  color: ${N800};
  letter-spacing: 0;
  margin-top: 16px;
  line-height: 62px;

  @media (max-width: ${preMobileBreakpoint}) {
    font-weight: 500;
    font-size: 48px;
    line-height: 56px;
    max-width: 600px;
    margin: 0;
  }

  @media (max-width: 510px) {
    font-size: 36px;
    line-height: 44px;
  }
`;

export const SubHeading = styled.h2`
  font-family: ${CharlieDisplayFontStack};
  margin-bottom: 32px;
  margin-top: 27px;
  font-size: 32px;
  font-weight: 500;
  color: ${N700};
  letter-spacing: 0;
  line-height: 36px;

  @media (max-width: ${preMobileBreakpoint}) {
    display: none;
  }
`;

export const HeaderLevel3 = styled.h3`
  margin-top: 39px;
  padding-bottom: 8px;
  font-weight: 500;
  font-size: 18px;
  color: ${N300};
  letter-spacing: 0.22px;
  line-height: 12px;
  text-transform: uppercase;

  @media (max-width: ${preMobileBreakpoint}) {
    font-size: 16px;
    margin-top: 11px;
  }

  @media (max-width: 510px) {
    padding-bottom: 0px;
    margin-bottom: 18px;
  }
`;

export const HeaderLevel4 = styled.h4`
  margin-top: 11px;
  margin-bottom: 24px;
  font-weight: 500;
  font-size: 24px;
  color: ${N300};
  letter-spacing: 0.22px;
  line-height: 28px;
  text-transform: uppercase;

  @media (max-width: ${preMobileBreakpoint}) {
    display: none;
  }
`;

export const FeatureListContainer = styled.div`
  @media (max-width: ${preMobileBreakpoint}) {
    display: none;
  }

  ul {
    list-style-type: none;
    padding: 6px 0 82px 20px;

    li {
      position: relative;
      font-weight: 400;
      margin-bottom: 16px;
      font-size: 20px;
      color: ${N500};
      letter-spacing: 0.3px;
      line-height: 28px;
      padding-left: 15px;
      font-family: ${CharlieDisplayFontStack};

      &::before {
        background-image: url("data:image/svg+xml,%3Csvg width='35px' height='35px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round'%3E%3Cg transform='translate(0.000000, -51.000000)' stroke='%230049B0' stroke-width='1.6'%3E%3Cg transform='translate(1.000000, 45.000000)'%3E%3Cg transform='translate(0.000000, 0.416810)'%3E%3Cpolyline points='1.52655666e-16 11.9766645 3.98219585 17 11 7'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        content: '';
        display: inline-block;
        position: absolute;
        left: -20px;
        top: 2px;
        height: 30px;
        width: 30px;
      }
    }
  }
`;

export const LargerTeamCTAContainer = styled.div`
  display: flex;
  flex-direction: row;

  &:before {
    background-image: url(${teamBase64});
    background-size: contain;
    background-repeat: no-repeat
    display: flex;
    content: ' ';
    height: 45px;
    width: 45px;
    margin: -9px 10px 0 0;
    align-self: center;
  }

  &.mobile {
    display: none;
    align-self: center;
    margin-top: 42px;

    @media (max-width: ${preMobileBreakpoint}) {
      display: flex;

      &:before {
        width: 55px;
        height: 55px;
      }
    }
  }

  &.desktop {
    @media (max-width: ${preMobileBreakpoint}) {
      display: none;
    }
  }
`;

export const LargerTeamCTACopyContainer = styled.div`
  flex-direction: column;
  line-height: 1;

  h5 {
    color: ${N900};
    font-size: 16px;
    font-weight: 500;
    margin: 0;
    text-transform: none;
  }

  a {
    font-weight: 600;
    font-size: 12px;
    color: ${B400};
    letter-spacing: 0.26px;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .mobile & {
    h5 {
      line-height: 24px;
    }

    a {
      font-size: 16px;
    }
  }
`;

export const NextButton = styled(Button)`
  font-family: ${CharlieDisplayFontStack};
  font-style: normal;
  background-color: ${B400} !important;
  border: 1px solid ${B400} !important;
  color: white !important;
  width: 145px !important;
  margin-bottom: 28px !important;
  font-weight: 300;
  height: 40px;
  white-space: nowrap;
  line-height: 38px;
  padding: 0 16px;
  border-radius: 3px;
  transition: all 250ms;
  justify-content: center;
  vertical-align: baseline !important;
  font-size: 100%;
  box-sizing: inherit;
  margin-left: auto;
  order: 2;

  @media (max-width: 440px) {
    width: 100% !important;
  }
`;
export const AgreeButton = styled(Button)`
  font-family: ${CharlieDisplayFontStack};
  font-style: normal;
  color: white !important;
  width: 288px !important;
  margin-bottom: 28px !important;
  font-weight: 300;
  height: 40px;
  white-space: nowrap;
  line-height: 38px;
  padding: 0 16px;
  border-radius: 3px;
  transition: all 250ms;
  justify-content: center;
  vertical-align: baseline !important;
  font-size: 100%;
  box-sizing: inherit;
  margin-left: 10px;
  order: 2;

  @media (max-width: 440px) {
    width: 100% !important;
  }
`;
export const SkipButton = styled(Button)`
  font-family: ${CharlieDisplayFontStack};
  font-style: normal;
  color: white !important;
  width: 70px !important;
  margin-bottom: 28px !important;
  font-weight: 300;
  height: 40px;
  white-space: nowrap;
  line-height: 38px;
  padding: 0 16px;
  border-radius: 3px;
  transition: all 250ms;
  justify-content: center;
  vertical-align: baseline !important;
  font-size: 100%;
  box-sizing: inherit;
  margin-left: auto;
  order: 2;

  @media (max-width: 440px) {
    width: 100% !important;
  }
`;
export const NextAndSkipButtonContainer = styled.div`
  display: flex;
  width: 100%;
  padding-top: 64px;

  &.expand {
    padding-top: 16px;
  }

  @media (max-width: 440px) {
    flex-direction: column;
  }
`;

export const NextButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 64px;

  &.expand {
    padding-top: 16px;
  }
`;

export const NoCreditCardRequiredText = styled.h4`
  font-weight: 500;
  font-size: 18px;
  color: ${N300} !important;
  letter-spacing: 0.22px;
  line-height: 12px;
  float: right;
  margin-bottom: 24px;
  text-transform: uppercase;
  margin-top: 2px;
  margin-left: auto;
  order: 2;

  @media (max-width: 440px) {
    float: none;
    margin: 0 auto 18px;
  }
`;
export const TermsAndConditionsText = styled.h5`
  font-family: ${CharlieTextFontStack}
  color: ${N300} !important;
  letter-spacing: 0.22px;
  float: right;
  margin-bottom: 24px;
  text-transform: uppercase;
  margin-top: 2px;
  margin-left: auto;
  order: 2;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;

  @media (max-width: 440px) {
    float: none;
    margin: 0 auto 18px;
  }
`;

export const HoverDialog = styled.div`
  font-family: ${CharlieDisplayFontStack}
  display: inline-block;
  width: 200px;
  background-color: ${N800};
  color: ${N0};
  text-align: left;
  border-radius: 6px;
  padding: 5px 5px;
  font-size: 14px;
  position: absolute;
  z-index: 1;
`;
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 25px;
  align-items: center;
  font-family: ${CharlieDisplayFontStack};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${N900};
  letter-spacing: 0.05em;

  a {
    text-decoration: none !important;
  }

  a:hover {
    text-decoration: underline !important;
  }

  svg {
    margin-bottom: 0 !important;

    @media (max-width: 510px) {
      max-width: 150px;
      left: 50% !important;
      transform: translateX(-50%);
    }
  }

  @media (max-width: 510px) {
    padding-top: 0px;
  }
`;

export const ModalButton = styled(Button)`
  font-family: ${CharlieTextFontStack};
  height: 40px !important;
  white-space: nowrap;
  padding: 0 12px !important;
  border-radius: 4px !important;
  transition: all 250ms;
  vertical-align: baseline !important;
  font-size: 100%;
  box-sizing: inherit;

  @media (max-width: 440px) {
    width: 100% !important;
  }
`;

export const ModalButtonContainer = styled.div<{
  justify?: 'start' | 'center' | 'end';
}>`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: ${(props) => props.justify ?? 'end'};
  gap: 16px;

  p {
    margin: 0;
  }

  @media (max-width: 440px) {
    flex-direction: column;
  }
`;

export const ModalTermsAndConditionsText = styled.div`
  margin: 0 0 0 auto;
  text-align: right;
  max-width: 280px;
  font-size: 12px !important;
  line-height: 18px !important;
  
  span, p {
    font-family: ${CharlieTextFontStack}
    color: ${N300} !important;
    letter-spacing: 0;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
  }
    
  @media (max-width: 440px) {
    float: none;
    margin: 0 auto 18px;
  }
`;

export const ModalWrapper = styled(Wrapper)`
  padding: 0;
  //margin: 0 92px 94px;
  margin: 0 68px 92px;
  overflow-y: hidden;
  height: 424px;
`;

export const ModalProductSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 231px;
`;

export const ModalAnimate = styled.div<{ activeIndex: number }>`
  transition: transform 0.6s;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 2px;
  transform: ${(props) =>
    `translateY(${(props.activeIndex === 0 ? 0 : 1) * -424}px)`};
`;

export const ModalSection = styled.div<{ current: number; index: number }>`
  height: 424px;
  transition: visibility 0.5s, opacity 0.5s;
  visibility: ${(props) =>
    props.current === props.index ? 'visible' : 'hidden'};
  opacity: ${(props) => (props.current === props.index ? 1 : 0)};
  order: ${(props) =>
    props.index === 0 ? 1 : props.current === props.index ? 2 : 3};
`;

export const ModalHeading = styled.h2`
  text-align: center;
  margin: 0;
  font-size: 36px !important;
  line-height: 44px !important;

  span {
    font-family: ${CharlieDisplayFontStack};
    font-size: 36px;
    font-weight: 400;
    color: ${N800};
    letter-spacing: 0;
    line-height: 44px;
  }
`;

export const ModalSubHeading = styled.h3`
  text-align: center;
  margin-bottom: 40px;
  margin-top: 16px;
  font-size: 16px !important;
  line-height: 24px !important;

  span {
    font-family: ${CharlieTextFontStack};
    font-size: 16px;
    font-weight: 400;
    color: ${N800};
    letter-spacing: 0;
    line-height: 24px;
  }
`;

export const ModalReadySubHeading = styled(ModalSubHeading)`
  margin-bottom: 28px;
  margin-top: 64px;
`;

export const ModalAddedSoftwareSubHeading = styled(ModalSubHeading)`
  margin-bottom: 8px;
  margin-top: 10px;
`;
